import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import { useUser } from "../../contexts/UserContext";
import api from "../../utils/api";
import InquiryTab from "./InquiryTab";

export default function InquiryDashboard() {
  const { user } = useUser();
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    if (!user) return;
    const isAdmin = user.role_id == '1';
    const isVerticalHead = user.role_id == '3' || ['26', '42', '43'].includes(String(user.designation_id));
    if (isAdmin || isVerticalHead) {
      setAllowed(true);
    } else {
      api.get('/client-inquiry/check-entitlement')
        .then(res => {
          setAllowed(!!res.data?.allowed);
        })
        .catch(() => {
          setAllowed(false);
        });
    }
  }, [user]);

  if (!user || allowed === null) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500 font-medium">
            {!user ? "Loading User Session..." : "Verifying authorization..."}
          </div>
        </div>
      </Layout>
    );
  }

  if (allowed === false) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-64">
          <div className="text-red-500 font-medium">You are not authorized to view this module.</div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="p-4 bg-slate-50 min-h-full space-y-6">
        {/* Module Title Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl font-black text-gray-800 tracking-tight uppercase">
              CLIENT INQUIRIES
            </h1>
            <p className="text-xs font-bold text-red-600 uppercase tracking-widest mt-1">
              Sales, Specifications & Interaction Tracking
            </p>
          </div>
        </div>

        {/* Render Inquiries Tab Directly */}
        <div className="bg-white p-6 rounded-2xl border border-gray-150 shadow-sm min-h-[500px]">
          <InquiryTab />
        </div>
      </div>
    </Layout>
  );
}
